// extracted by mini-css-extract-plugin
export default {"root":"RuleConfiguratorPage_root__Jjcp3","ruleButtonContainer":"RuleConfiguratorPage_ruleButtonContainer__2a7dO","btn":"RuleConfiguratorPage_btn__oiVpJ"};